var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topLink"},[_c('ul',_vm._l((_vm.linkList),function(list,index){return _c('li',{key:index,attrs:{"data-index":index}},[_c('a',{attrs:{"href":list.link,"target":"_blank"}},[_vm._v(_vm._s(list.name))]),_vm._v(" "),((index+1) != _vm.linkList.length)?_c('span',{staticClass:"divider"},[_vm._v("|")]):_vm._e()])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4ea6fd2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/com/topLink.vue
// module id = null
// module chunks = 